'use strict'

/**
 * Composant Count Down dans les partials
 *
 * Doc : https://www.w3schools.com/howto/howto_js_countdown.asp
 */

// Appels des différents compteurs
handleCountDown('#j_countdown_jhms', "Dommage, l'offre n'est plus valable")
handleCountDown('#j_countdown_jhms2', '00h 00m 00s.')
handleCountDown('#j_countdown_jhms3', '00h 00m 00s')
handleCountDown(
    '#j_countdown_digital',
    'Article exp&eacute;di&eacute; en 24h',
    false,
    '.j_libcountdown',
    true
)

/**
 * Méthode qui gère la mise à jour du count down
 * @param {string} selector Sélecteur CSS du count down
 * @param {string} endingMessage Message de fin de count down
 * @param {boolean} hasDays Si le count down affiche des jours
 * @param {string} endMessageContainerSelector Sélecteur CSS pour le message de fin
 * @param {boolean} hasLigthDisplay Affichage sans h et m
 */
function handleCountDown(
    selector,
    endingMessage,
    hasDays = true,
    endMessageContainerSelector = '',
    hasLigthDisplay = false
) {
    const countDownElement = $(selector)

    if (countDownElement.length === 0) {
        return
    }

    const deadline = countDownElement.attr('data-deadline')

    const x = setInterval(function () {
        const now = new Date().getTime()

        // Temps restant
        const remainingTime = deadline - now

        // Calculs des jours, heures, minutes et secondes
        const hours = Math.floor(
            (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        )
        const minutes = Math.floor(
            (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
        )
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)
        const zero = '0'

        let countDownContent =
            (hours < 10 ? zero + hours : hours) +
            (hasLigthDisplay ? ':' : 'h ') +
            (minutes < 10 ? zero + minutes : minutes) +
            (hasLigthDisplay ? ':' : 'm ') +
            (seconds < 10 ? zero + seconds : seconds) +
            (hasLigthDisplay ? '' : 's')

        if (hasDays) {
            const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24))
            countDownContent = (days > 0 ? days + 'j ' : '') + countDownContent
        }

        // Affichage du temps restant
        countDownElement.html(countDownContent)

        // If the count down is finished, write some text
        if (remainingTime < 0) {
            clearInterval(x)

            if (endMessageContainerSelector === '') {
                countDownElement.html(endingMessage)
                return
            }

            $(endMessageContainerSelector).html(endingMessage)
        }
    }, 10)
}
